/**
 * Sleep Doctor Simple Product Component
 * Handles product variants and direct checkout functionality
 * Uses simple dropdown selectors to avoid conflicts with multiple products
 */

// eslint-disable-next-line no-undef
if (!customElements.get('sleepdoctor-simple-product')) {
  // eslint-disable-next-line no-undef
  class SleepdoctorSimpleProduct extends HTMLElement {
    connectedCallback () {
      // Store original button text for all buttons
      this.querySelectorAll('button[name="add"]').forEach(button => {
        const span = button.querySelector('span')
        if (span) {
          button.dataset.originalText = span.textContent.trim()
        }
      })

      this.setupVariantSelectors()
    }

    setupVariantSelectors () {
      // Find all simple variant selectors
      const variantSelectors = this.querySelectorAll('.simple-variant-select')

      variantSelectors.forEach(selector => {
        selector.addEventListener('change', (e) => {
          this.handleVariantChange(e.target)
        })

        // Initialize the state based on selected variant
        this.handleVariantChange(selector)
      })
    }

    formatMoney (cents) {
      const dollars = cents / 100
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: dollars % 1 === 0 ? 0 : 2
      }).format(dollars)
    }

    handleVariantChange (selector) {
      const selectedOption = selector.options[selector.selectedIndex]
      const productBlock = selector.closest('.product-option-block')

      if (!productBlock || !selectedOption) return

      const variantId = selectedOption.value
      const price = parseInt(selectedOption.dataset.price)
      const comparePrice = parseInt(selectedOption.dataset.comparePrice)
      const available = selectedOption.dataset.available === 'true'

      // Update the hidden variant input in the form
      const variantInput = productBlock.querySelector('input[name="id"]')
      if (variantInput) {
        variantInput.value = variantId
        variantInput.disabled = !available
      }

      // Update price display
      const priceElement = productBlock.querySelector('.product-option-price .price')
      if (priceElement) {
        priceElement.textContent = this.formatMoney(price)
      }

      // Update compare price
      const comparePriceElement = productBlock.querySelector('.product-option-price .compare-price')
      if (comparePriceElement) {
        if (comparePrice && comparePrice > price) {
          comparePriceElement.textContent = this.formatMoney(comparePrice)
          comparePriceElement.style.display = ''
        } else {
          comparePriceElement.style.display = 'none'
        }
      }

      // Update add to cart button
      const addToCartBtn = productBlock.querySelector('button[type="submit"][name="add"]')
      if (addToCartBtn) {
        addToCartBtn.disabled = !available
        const span = addToCartBtn.querySelector('span')
        if (span) {
          if (available) {
            span.textContent = addToCartBtn.dataset.originalText || 'Add to Cart'
          } else {
            span.textContent = 'Sold Out'
          }
        }
      }
    }
  }

  // eslint-disable-next-line no-undef
  customElements.define('sleepdoctor-simple-product', SleepdoctorSimpleProduct)
}
